<template>
    <div>
        <div v-show="showRequestReviewsForm">
        <div class="row">
            <div class="col-12">
                <div class="alert alert-warning">
                    Enable and setup up the url's for each review site that you want to write reviews on.
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-google': form.write_review_google}"
                    @click="writeReviewSite('write_review_google')">
                    <i class="fab fa-google"></i>
                    Google
                </button>
            </div>
            <div class="col-9">
                <div class="row">
                    <div class="col-11">
                        <input-text placeholder="PlaceID"
                            v-model="form.write_review_google_url"
                            :form="form" field="write_review_google_url"
                            :readonly="!form.write_review_google"
                        />
                    </div>
                    <div class="col-1">
                        <a href="https://developers.google.com/places/place-id" data-toggle="tooltip"
                            target="_blank" title="What is my PlaceID?"><i class="fa fa-question"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-facebook': form.write_review_facebook}"
                    @click="form.write_review_facebook = !form.write_review_facebook">
                    <i class="fab fa-facebook"></i>
                    Facebook
                </button>
            </div>
            <div class="col-9">
                <input-text placeholder="https://www.facebook.com/.../reviews"
                    v-model="form.write_review_facebook_url"
                    :form="form" field="write_review_facebook_url"
                    :readonly="!form.write_review_facebook"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-yelp': form.write_review_yelp}"
                    @click="writeReviewSite('write_review_yelp')">
                    <i class="fab fa-yelp"></i>
                    Yelp
                </button>
            </div>
            <div class="col-9">
                <input-text placeholder="https://www.7yelp.com/writeareview/biz/..."
                    v-model="form.write_review_yelp_url"
                    :form="form" field="write_review_yelp_url"
                    :readonly="!form.write_review_yelp"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-tripadvisor': form.write_review_trip_advisor}"
                    @click="writeReviewSite('write_review_trip_advisor')">
                    <i class="fab fa-tripadvisor"></i>
                    TripAdvisor
                </button>
            </div>
            <div class="col-9">
                <input-text placeholder="https://www.tripadvisor.com/UserReviewEdit..."
                    v-model="form.write_review_trip_advisor_url"
                    :form="form" field="write_review_trip_advisor_url"
                    :readonly="!form.write_review_trip_advisor"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-capterra': form.write_review_capterra}"
                    @click="writeReviewSite('write_review_capterra')">
                    Capterra
                </button>
            </div>
            <div class="col-9">
                <input-text placeholder="https://www.capterra.com/reviews/.../new"
                    v-model="form.write_review_capterra_url"
                    :form="form" field="write_review_capterra_url"
                    :readonly="!form.write_review_capterra"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-software-advice': form.write_review_software_advice}"
                    @click="writeReviewSite('write_review_software_advice')">
                    Software Advice
                </button>
            </div>
            <div class="col-9">
                <input-text placeholder="https://softwareadvice.com/..."
                    v-model="form.write_review_software_advice_url"
                    :form="form" field="write_review_software_advice_url"
                    :readonly="!form.write_review_software_advice"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-g2-crowd': form.write_review_g2_crowd}"
                    @click="writeReviewSite('write_review_g2_crowd')">
                    G2 Crowd
                </button>
            </div>
            <div class="col-9">
                <input-text placeholder="https://www.g2crowd.com/..."
                    field="write_review_g2_crowd_url"
                    v-model="form.write_review_g2_crowd_url"
                    :form="form"
                    :readonly="!form.write_review_g2_crowd"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-golf-now':form.write_review_golf_now}"
                    @click="writeReviewSite('write_review_golf_now')">
                    Golf Now
                </button>
            </div>
            <div class="col-9">
                <input-text placeholder="https://www.golfnow.com/..."
                    field="write_review_golf_now_url"
                    v-model="form.write_review_golf_now_url"
                    :form="form"
                    :readonly="!form.write_review_golf_now"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-indeed':form.write_review_indeed}"
                    @click="writeReviewSite('write_review_indeed')">
                    Indeed
                </button>
            </div>
            <div class="col-9">
                <input-text placeholder="https://www.indeed.com/cmp/.../reviews"
                    field="write_review_indeed_url"
                    v-model="form.write_review_indeed_url"
                    :form="form"
                    :readonly="!form.write_review_indeed"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-glassdoor':form.write_review_glassdoor}"
                    @click="writeReviewSite('write_review_glassdoor')">
                    Glassdoor
                </button>
            </div>
            <div class="col-9">
                <input-text placeholder="https://www.glassdoor.com/Overview/....htm"
                    field="write_review_glassdoor_url"
                    v-model="form.write_review_glassdoor_url"
                    :form="form"
                    :readonly="!form.write_review_glassdoor"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-healthgrades':form.write_review_healthgrades}"
                    @click="writeReviewSite('write_review_healthgrades')">
                    Healthgrades
                </button>
            </div>
            <div class="col-9">
                <input-text placeholder="https://www.healthgrades.com/.../..."
                    field="write_review_glassdoor_url"
                    v-model="form.write_review_healthgrades_url"
                    :form="form"
                    :readonly="!form.write_review_healthgrades"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-realself':form.write_review_realself}"
                    @click="writeReviewSite('write_review_realself')">
                    Realself
                </button>
            </div>
            <div class="col-9">
                <input-text placeholder="https://www.realself.com/review/write?dr_id=..."
                    field="write_review_realself_url"
                    v-model="form.write_review_realself_url"
                    :form="form"
                    :readonly="!form.write_review_realself"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-golf-advisor':form.write_review_golf_advisor}"
                    @click="writeReviewSite('write_review_golf_advisor')">
                    Golf Advisor
                </button>
            </div>
            <div class="col-9">
                <input-text placeholder="https://www.golfadvisor.com/courses/..."
                    field="write_review_golf_advisor_url"
                    v-model="form.write_review_golf_advisor_url"
                    :form="form"
                    :readonly="!form.write_review_golf_advisor"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-zillow':form.write_review_zillow}"
                    @click="writeReviewSite('write_review_zillow')">
                    Zillow
                </button>
            </div>
            <div class="col-9">
                <input-text placeholder="https://www.zillow.com/lender-profile/..."
                    field="write_review_zillow_url"
                    v-model="form.write_review_zillow_url"
                    :form="form"
                    :readonly="!form.write_review_zillow"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-next-door':form.write_review_next_door}"
                    @click="writeReviewSite('write_review_next_door')">
                    NextDoor
                </button>
            </div>
            <div class="col-9">
                <input-text placeholder="https://nextdoor.com/pages/..."
                    field="write_review_next_door_url"
                    v-model="form.write_review_next_door_url"
                    :form="form"
                    :readonly="!form.write_review_next_door"
                />
            </div>
        </div>
        <div v-if="customReviewList.length">
            <div v-for="customLink of customReviewList">
                <div class="row pb-3">
                    <div class="col-3">
                        <button class="btn w-100" :style="{backgroundColor:customLink.bg_btn_color}"
                                @click="editCustomLink(customLink)">
                            {{customLink.btn_text}}
                        </button>
                    </div>
                    <div class="col-9">
                        <div class="input-group">
                            <input type="text" class="form-control" :placeholder="customLink.btn_link" :readonly="true">
                            <div class="input-group-append">
                                <button class="btn btn-danger" @click="removeCustomLinks(customLink)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <button class="btn btn-block btn-success"
                        @click="addNewCustomReview">
                    <i class="fa fa-plus"></i> Add Custom Review Link
                </button>
            </div>
        </div>
        <div class="modal-footer mt-2 pr-0 pb-0 pl-0">
            <button class="btn btn-default" type="button" data-dismiss="modal">
                Close
            </button>
            <button-loading type="button" class="btn btn-primary ml-2"
                :loading="form.submitting"
                @click="save">
                Save
            </button-loading>
        </div>
        </div>
        <modal ref="modal" size="lg" :has-footer="false" :center="true" @closed="closeNewCustomReviewModal">
            <span slot="title">New Review Link Button</span>
            <div class="form-group">
                <label for="bgColor">Background Button Color</label>
                <colorpicker @input="colorChange"
                    :color="customLinkForm.bg_btn_color"
                    v-model="customLinkForm.bg_btn_color"
                />
            </div>
            <div class="form-group">
                <input-text v-model="customLinkForm.btn_text" :form="customLinkForm" field="btn_text" label="Button Text">
                </input-text>
            </div>
            <div class="form-group">
                <input-text v-model="customLinkForm.btn_link" :form="customLinkForm" field="btn_link" label="Button Review Link">
                </input-text>
            </div>
            <fieldset class="border p-3 mb-3 rounded" id="preview-custom-link-button">
                <legend class="px-2 w-auto customization__legend">
                    Preview Button
                </legend>
                <div class="text-center">
                        <a :href="customLinkForm.btn_link" :style="customButtonStyle" @click.prevent="goToTestLink" >
                            {{ customLinkForm.btn_text }}
                        </a>
                </div>
            </fieldset>
            <div class="modal-footer mt-2 pr-0 pb-0 pl-0">
                <button class="btn btn-default" type="button" @click="closeNewCustomReviewModal">
                    Close
                </button>
                <button-loading type="button" class="btn btn-primary ml-2"
                                :loading="customLinkForm.submitting"
                                @click="saveCustomLink">
                    Save
                </button-loading>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: ['location'],

        data() {
            return {
                form: new Form(),
                customReviewList: [],
                customLinkForm: new Form({
                    bg_btn_color: '#0050ff',
                    btn_text: 'Custom Text Here!',
                    btn_link: '',
                    location_id: '',
                    custom_request_review_link_id: '',
                }),
                customButtonStyle: {
                    backgroundColor: "#0050ff",
                    textTransform: "capitalize",
                    fontSize: "16px",
                    display: "block",
                    textDecoration: "none",
                    color: "#FFF",
                    padding: "0.6rem 2rem",
                    borderRadius: "0.25rem",
                    cursor: "pointer",
                    marginBottom: "0.3rem",
                    outline: "none",
                },
                showRequestReviewsForm: true,
                enableUpdateCustomLink: false,
                bg_btn_color: "#0050ff",
            }
        },
        watch: {
            location: {
                immediate: true,
                handler() {
                    if (this.location) {
                        if(!this.customReviewList.length){
                            this.getCustomReviewLinks();
                        }
                        this.form = new Form({
                            location_id                     : this.location.id,
                            write_review_google             : !!this.location.write_review_google_url,
                            write_review_google_url         : this.location.write_review_google_url,
                            write_review_facebook           : !!this.location.write_review_facebook_url,
                            write_review_facebook_url       : this.location.write_review_facebook_url,
                            write_review_yelp               : !!this.location.write_review_yelp_url,
                            write_review_yelp_url           : this.location.write_review_yelp_url,
                            write_review_trip_advisor_url   : this.location.write_review_trip_advisor_url,
                            write_review_trip_advisor       : !!this.location.write_review_trip_advisor_url,
                            write_review_capterra_url       : this.location.write_review_capterra_url,
                            write_review_capterra           : !!this.location.write_review_capterra_url,
                            write_review_software_advice_url: this.location.write_review_software_advice_url,
                            write_review_software_advice    : !!this.location.write_review_software_advice_url,
                            write_review_g2_crowd_url       : this.location.write_review_g2_crowd_url,
                            write_review_g2_crowd           : !!this.location.write_review_g2_crowd_url,
                            write_review_golf_now_url       : this.location.write_review_golf_now_url,
                            write_review_golf_now           : !!this.location.write_review_golf_now_url,
                            write_review_indeed_url         : this.location.write_review_indeed_url,
                            write_review_indeed             : !!this.location.write_review_indeed_url,
                            write_review_glassdoor_url      : this.location.write_review_glassdoor_url,
                            write_review_glassdoor          : !!this.location.write_review_glassdoor_url,
                            write_review_healthgrades_url   : this.location.write_review_healthgrades_url,
                            write_review_healthgrades       : !!this.location.write_review_healthgrades_url,
                            write_review_realself_url       : this.location.write_review_realself_url,
                            write_review_realself           : !!this.location.write_review_realself_url,
                            write_review_golf_advisor_url   : this.location.write_review_golf_advisor_url,
                            write_review_golf_advisor       : !!this.location.write_review_golf_advisor_url,
                            write_review_zillow_url         : this.location.write_review_zillow_url,
                            write_review_zillow             : !!this.location.write_review_zillow_url,
                            write_review_next_door_url      : this.location.write_review_next_door_url,
                            write_review_next_door          : !!this.location.write_review_next_door_url,
                        });

                        return;
                    }

                    this.form = new Form();
                }
            }
        },

        methods: {
            writeReviewSite(site) {
                this.form[site] = !this.form[site];
                if (!this.form[site]) this.form[`${site}_url`] = null;
            },

            save() {
                return this.form.put(this.$laroute.route('request-reviews.update', {location: this.form.location_id}))
                    .then(({data}) => {
                        this.$emit('save-location', data.id);
                        swal.fire({
                            title: 'Location Saved!',
                            type: 'success',
                        })
                    })
                    .catch(error => console.error(error));
            },

            addNewCustomReview() {
                this.enableUpdateCustomLink = false;
                this.customLinkFormSetup();
            },

            async saveCustomLink() {
                if(this.enableUpdateCustomLink){
                    await this.customLinkForm.put('update-location-custom-reviews/' + this.customLinkForm.location_id).then(({data}) => {
                        this.customReviewList = data;
                        this.$refs.modal.close();
                        this.showRequestReviewsForm = true;
                    }).catch(error => console.error(error));
                }else{
                    await this.customLinkForm.post('location-custom-reviews/' + this.customLinkForm.location_id).then(({data}) => {
                        this.customReviewList = data;
                        this.$refs.modal.close();
                        this.showRequestReviewsForm = true;
                    }).catch(error => console.error(error));
                }
            },

            async removeCustomLinks(customLink) {
                const result = await this.$confirmDialog();
                if (!result) return;
                await this.$http.delete('delete-location-custom-review-link/' + customLink.id).then(() => {
                    const index = this.customReviewList.findIndex(c => c.id === customLink.id);
                    this.customReviewList.splice(index, 1);
                    });
                swal.close();
            },

            closeNewCustomReviewModal() {
                this.$refs.modal.close();
                this.showRequestReviewsForm = true;
            },
            colorChange(newColor) {
                this.customButtonStyle.backgroundColor = newColor;
            },
            goToTestLink() {
                window.open(this.customLinkForm.btn_link, '_blank');
            },
            editCustomLink(customLink) {
                this.enableUpdateCustomLink = true;
                this.customLinkFormSetup(customLink);

            },
            getCustomReviewLinks() {
                if(this.location.id != null) {
                    this.$http.get('get-location-custom-reviews/' + this.location.id).then(({data}) => {
                        this.customReviewList = data;
                    }).catch(error => console.error(error));
                }
            },

            customLinkFormSetup (customLink = null) {
                this.customLinkForm = new Form({
                    bg_btn_color: customLink ? customLink.bg_btn_color : "#0050ff",
                    btn_text: customLink ? customLink.btn_text : 'Custom Text Here!',
                    btn_link: customLink ? customLink.btn_link : '',
                    location_id: this.location.id,
                    custom_request_review_link_id: customLink ? customLink.id : '',
                });
                this.colorChange(this.customLinkForm.bg_btn_color);
                this.showRequestReviewsForm = false;
                this.$refs.modal.open();
            }

        }
    }
</script>
